
$(function(){
    $('#select1, #select2, #select3').multiSelect();
});


var i = 0;
function move() {
  if (i == 0) {
    i = 1;
    var elem = document.getElementById("myBar");
    var width = 1;
    var id = setInterval(frame, 40);
    function frame() {
      if (width >= 100) {
        clearInterval(id);
        i = 0;
        move();
      } else {
        width++;
        elem.style.width = width + "%";
        // elem.innerHTML = width + "%";
          if(width==2)
        {
        	document.getElementById("one").classList.add("clstouch");
        	document.getElementById("two").classList.remove("clstouch");
        	document.getElementById("three").classList.remove("clstouch");
        }
        if(width==40)
        {
        	document.getElementById("one").classList.remove("clstouch");
        	document.getElementById("two").classList.add("clstouch");
        	document.getElementById("three").classList.remove("clstouch");
        }
        if(width==70)
        {
        	document.getElementById("one").classList.remove("clstouch");
        	document.getElementById("two").classList.remove("clstouch");
        	document.getElementById("three").classList.add("clstouch");
        }
      }
    }
  }
} 
window.onload = function() {
move();
}	